import { useEffect, useState } from "react";
import api, { fmtErr } from "@/shared/lib/api";
import { PageHeader, Btn, Input, Field } from "@/shared/components/UI";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/shared/lib/auth";

const TYPES = [
  { key: "material_category", label: "Material Category" },
  { key: "thickness", label: "Thickness (Acrylic)" },
  { key: "color", label: "Color (Acrylic)" },
  { key: "finish", label: "Finish / Type" },
  { key: "size", label: "Sheet Size" },
  { key: "supplier", label: "Supplier / Brand" },
  { key: "storage_location", label: "Storage Location" },
];

export default function Masters() {
  const { user } = useAuth();
  const [active, setActive] = useState("material_category");
  const [items, setItems] = useState([]);
  const [val, setVal] = useState("");

  function load() { api.get(`/masters/${active}`).then((r) => setItems(r.data)); }
  useEffect(load, [active]);

  async function add(e) {
    e.preventDefault();
    if (!val.trim()) return;
    try { await api.post(`/masters/${active}`, { value: val.trim() }); setVal(""); load(); toast.success("Added"); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
  }

  async function del(id) {
    if (!confirm("Delete this master?")) return;
    try { await api.delete(`/masters/${active}/${id}`); load(); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
  }

  return (
    <div className="p-6 lg:p-10" data-testid="masters-page">
      <PageHeader kicker="Settings" title="Master data" />

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
        <div className="card-flat p-2 space-y-1">
          {TYPES.map((t) => (
            <button key={t.key} onClick={() => setActive(t.key)} data-testid={`master-tab-${t.key}`}
              className={`w-full text-left px-3 h-11 text-sm font-medium ${active === t.key ? "bg-zinc-900 text-white" : "hover:bg-zinc-100"}`}>
              {t.label}
            </button>
          ))}
        </div>

        <div className="card-flat p-5 lg:col-span-3 space-y-4">
          <h3 className="font-display font-bold tracking-tight">{TYPES.find((t) => t.key === active).label}</h3>
          <form onSubmit={add} className="flex gap-2">
            <Input value={val} onChange={(e) => setVal(e.target.value)} placeholder={`Add new ${active}`} data-testid="master-input" />
            <Btn type="submit" data-testid="master-add"><Plus className="w-4 h-4" /> Add</Btn>
          </form>
          <div className="border border-zinc-200">
            {items.length === 0 && <div className="p-6 text-center text-zinc-400 text-sm">No values</div>}
            {items.map((i) => (
              <div key={i.id} className="flex items-center justify-between px-4 h-11 border-b border-zinc-100 last:border-0 text-sm">
                <span className="font-mono">{i.value}</span>
                {user?.role === "admin" && (
                  <button onClick={() => del(i.id)} className="text-rose-600 hover:bg-rose-50 p-1.5">
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
